var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-scroll',[_c('div',{staticClass:"cd__image-slider"},_vm._l((_vm.imageSliderObject),function(item){return _c('CdImageSliderItem',{key:item.id,attrs:{"imageUrl":item.url}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }